<style lang="less" scoped>
.content{
  margin:30px 50px;
  position: relative;
  .contentTitle{
    width: 220px;
    height:44px;
    font-size: 20px;
    box-sizing: border-box;
    line-height: 44px;
    text-align: center;
    color:@primary-color;
    border:1px solid @primary-color;
    border-radius:12px;
    margin: auto;
  }
  .notice{
    margin-top: 20px;;
    padding:20px;
    background: #f8f8f8;
    border-radius: 4px;
  }
  .textArea{
    margin-top: 20px;
  }
  .btn{
    width:100%;
    height:60px;
    margin-top: 20px;
    text-align: right;
    .edit,.cancel,.sure{
      width:120px;
      height:30px;
      line-height:30px;
      text-align:Center;
      font-size: 18px;
    }
    .edit{
      background: @primary-color;
      color:#fff;
    }
    .cancel{
      background: #fbf6ef;
      color:@primary-color;
      margin-right: 20px;
    }
    .sure{
      background: @primary-color;
      color:#fff;
    }
  }
}
</style>
<template>
<div class="content">
  <div class="contentTitle">群公告</div>
    <p class="notice" v-if="editInfo">
      {{notice}}
      <a-empty v-if="!notice"/>
    </p>
    <a-textarea class="textArea" :autoSize="{ minRows: 5, maxRows: 10 }" v-if="showInfo" :defaultValue="notice" @change="textChange"/>
    <div class="btn">
      <a-button class="edit" v-if="editInfoBtn" @click="editInfoFun">编辑</a-button>
      <a-button class="cancel" v-if="showInfo" @click="cancelFun">取消</a-button>
      <a-button class="sure" v-if="showInfo" @click="sureFun">确认</a-button>
    </div>
  </div>
</template>

<script>
import shareState from '../../utils/shareState.js'
export default {
  name: 'Notice',
  data () {
    return {
      shareData: shareState.state,
      notice: '',
      showInfo: false,
      editInfo: true,
      editInfoBtn: true,
      textInput: ''
    }
  },
  watch: {
    $route () {
      this.getClassNotice()
    }
  },
  beforeMount () {
    this.getClassNotice()
  },
  methods: {
    getClassNotice () {
      // const groupid = this.$route.params.groupid
      // const myClass = this.$getUserInfo().group.filter(c => c.groupTag === groupid)
      // console.log('myClass', myClass)
      // if (myClass.length > 0) {
      //   this.notice = myClass[0].intro
      // } else {
      //   this.notice = ''
      // }
      const groupid = this.$route.params.groupid
      //const myClass = JSON.parse(localStorage.getItem('newClassInfo')).filter(c => c.groupTag === groupid)
      const myClass = this.shareData.classInfo.filter(c => c.groupTag === groupid)
      if (myClass.length > 0) {
        this.notice = myClass[0].intro
      } else {
        this.notice = ''
      }
    },
    textChange (e){
      this.textInput = e.target.value
    },
    editInfoFun () {
      this.showInfo = true
      this.editInfoBtn = false
      this.editInfo = false
    },
    cancelFun () {
      this.showInfo = false
      this.editInfoBtn = true
      this.editInfo = true
    },
    sureFun () {
      if(!this.textInput) return
      const param = {
        id: this.$getUserInfo().id,
        classInfo: this.textInput
      }
      this.$fetch({
        url: this.$baseUrl+ 'ebook/class/common/editClassInfo',
        body: param
      }).done(res=>{
        if(res && res.success && res.resultCode === 0){
          this.$message.success('编辑成功')
          this.showInfo = false
          this.editInfoBtn = true
          this.editInfo = true
          this.notice = this.textInput
        }
      })
    }
  }
}
</script>
